import React from 'react';
import {
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Tabs,
    Tab,
    Typography,

} from "@material-ui/core";
import useStyles from '../styles/styles';
import {Prism as SyntaxHighlighter} from 'react-syntax-highlighter';
import {base16AteliersulphurpoolLight} from 'react-syntax-highlighter/dist/esm/styles/prism';
import {addDays, format} from 'date-fns';
import diagram from '../images/amp.png'

const PostingInstructions = () => {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const [codeTab, setCodeTab] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleCodeTab = (event, newValue) => {
        setCodeTab(newValue);
    };


    const sourceKeyUrl = (new URL(window.location)).searchParams.get("sourceKey");

    const sourceKeySet = sourceKeyUrl ? true : false;

    const sourceKey = sourceKeySet ? sourceKeyUrl : 'XXXXXXXX-XYXX-XXXX-XXXX-XXXXXXXXXXXX';

    const payDate1 = format(addDays(new Date(), 7), 'yyyy-MM-dd');

    const payDate2 = format(addDays(new Date(), 37), 'yyyy-MM-dd');

    function TabPanel(props) {
        const { children, value, value2, index, ...other } = props;

        return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`wrapped-tabpanel-${index}`}
            aria-labelledby={`wrapped-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={3} pt={1}>{children}</Box>}
        </Typography>
        );
    }

    function TabPanel2(props) {
        const {children, value, index, ...other} = props;

        return (
            <Typography
                component="div"
                role="tabpanel"
                hidden={value !== index}
                id={`wrapped-tabpanel-${index}`}
                aria-labelledby={`wrapped-tab-${index}`}
                {...other}
            >
                {value === index && <Box p={3} pt={1}>{children}</Box>}
            </Typography>
        );
    }

    return (
        <>
            <Typography variant="h2" gutterBottom>
                AMP Posting Instructions
            </Typography>
            <Typography variant="body1">
                <p>
                    The /amp/ endpoint allows you to access the Acquire Interactive accelerated marketplace buyers,
                    using a price reject protocol that is compatible with most ping tree platforms. Buyers are
                    contacted concurrently, and bid on leads, allowing you to maximize earnings while conserving
                    valuable time.
                </p>
            </Typography>

            <Paper className={`${classes.paper} ${classes.autoWidth}`}>
                <Table className={`${classes.table} ${classes.marginAuto}`}  size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell variant="head">Endpoint</TableCell>
                            <TableCell variant="head">Address</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell>Test</TableCell>
                            <TableCell>https://test-api.acquireinteractive.com/amp/</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Production</TableCell>
                            <TableCell>https://acceleratedmarketplace.com/amp/</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Paper>

            <Typography variant="body1">
                <p>
                    The API is authenticated using <a href={"https://www.httpwatch.com/httpgallery/authentication/"}>HTTP Basic Authentication</a> over TLS.
                    Your account manager will provide you with a username and password combination for both the test and prod environments.
                </p>
                <p>
                    Example: username=david, password=strongpassword -- this combination would yield an authorization header as follows: "Authorization: Basic ZGF2aWQ6c3Ryb25ncGFzc3dvcmQ=".
                </p>

                {sourceKeySet ? (
                    <p> The JSON payload will also include a "Source Key" that identified the source of your leads and ensures you are paid for ACCEPTED leads, your source key is "{sourceKey}".</p>
                ) : null}

                <br /><br />
            </Typography>

            <Typography variant="h2">
                Process Diagram
            </Typography>
            <Typography variant="body1">
                <img src={diagram} style={{maxWidth: '1200px'}}/>
                <br /><br />
            </Typography>

            <Typography variant="h3" gutterBottom>
                Phase I: &quot;Ping&quot;
            </Typography>

            <Paper className={classes.paper}>
                <Table className={classes.table} size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell variant="head">Field&nbsp;Name</TableCell>
                            <TableCell variant="head">Data&nbsp;Type</TableCell>
                            <TableCell variant="head">Required</TableCell>
                            <TableCell variant="head">Example</TableCell>
                            <TableCell variant="head">Notes</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell>source_key</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>{sourceKey}</TableCell>
                            <TableCell>Required, the traffic source identifier provided by Acquire
                                Interactive</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>first_name</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>Joesph</TableCell>
                            <TableCell>Required, the customers first name, minimum number of characters accepted is 2,
                                maximum is 64.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>middle_name</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>B</TableCell>
                            <TableCell>If present, the customers middle name, minimum number of characters accepted is
                                2, maximum is 64.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>last_name</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>Doe</TableCell>
                            <TableCell>Required, the customers last name, minimum number of characters accepted is 2,
                                maximum is 64.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>primary_email</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>joe.b.doe@acquireinteractive.com</TableCell>
                            <TableCell>Required, the customers valid, well formed email address, maximum length is 128
                                characters.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>home_phone</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>5123486640</TableCell>
                            <TableCell>
                                A valid home_phone or mobile_phone for the customer is required. Both can be
                                provided.<br/>
                                Send only the 10 significant numbers that make up the phone number.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>mobile_phone</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>3314727185</TableCell>
                            <TableCell>
                                A valid mobile_phone or home_phone for the customer is required. Both can be
                                provided.<br/>
                                Send only the 10 significant numbers that make up the phone number.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>best_call_time</TableCell>
                            <TableCell>Enum</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>EVENING</TableCell>
                            <TableCell>
                                Best time to contact customer, one of the following values:<br/>
                                MORNING, AFTERNOON, EVENING (case sensitive)</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>date_of_birth</TableCell>
                            <TableCell>Date</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>1977-06-27</TableCell>
                            <TableCell>Required, the customers date of birth in YYYY-MM-DD format. Date must represent
                                applicants age as 18 or older as of this day.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>ssn</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>200304000</TableCell>
                            <TableCell>Required, send only the 9 significant numbers that make up the customers Social
                                Security Number.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>street_address</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>123 S. Main St.</TableCell>
                            <TableCell>Required, the customers street address, minimum number of characters accepted is
                                6, maximum is 128.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>street_address2</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>Apt 101</TableCell>
                            <TableCell>The customers additional street address, maximum number of characters accepted is
                                128.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>city</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>Kansas City</TableCell>
                            <TableCell>Required, the customers city, minimum number of characters accepted is 1, maximum
                                is 128.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>state</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>KS<br/>Kansas</TableCell>
                            <TableCell>Required, the customers state, a valid two letter state abbreviation or the full
                                state name</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>zip</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>66102<br/>66102-3225</TableCell>
                            <TableCell>Required, send either the 5 digit ZIP Code or the 10 digit ZIP+4 with the dash in
                                it.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>residence_type</TableCell>
                            <TableCell>Enum</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>OWN</TableCell>
                            <TableCell>
                                Required, does the customer own or rent their residence, one of the following
                                values:<br/>
                                RENT, OWN (case sensitive)</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>residence_length_months</TableCell>
                            <TableCell>Int</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>25</TableCell>
                            <TableCell>Required, Number of months the customer has been at their residence</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>military</TableCell>
                            <TableCell>Boolean</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>true<br/>false</TableCell>
                            <TableCell>Required, is the customer active duty military?</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>work_phone</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>7605034396</TableCell>
                            <TableCell>Required, send only the 10 significant numbers that make up the phone
                                number.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>work_ext</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>766</TableCell>
                            <TableCell>The customers work extension, maximum number of characters accepted is 10 digits
                                (only numbers allowed).</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>bank_name</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>First National Bank of Charlotte</TableCell>
                            <TableCell>Required, name of the customers banking institution. Must be between 1 and 150
                                characters.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>bank_routing</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>123123123</TableCell>
                            <TableCell>Required, customers bank account routing number. Must be exactly nine digits,
                                (only numbers allowed).</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>bank_account</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>987654324</TableCell>
                            <TableCell>Required, customers valid bank account number. Must be between 2 and 21 alpha
                                numeric characters.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>bank_account_type</TableCell>
                            <TableCell>Enum</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>CHECKING</TableCell>
                            <TableCell>Required, customers type of bank account. CHECKING or SAVINGS (case
                                sensitive)</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>months_at_bank</TableCell>
                            <TableCell>Int</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>27</TableCell>
                            <TableCell>Number of months the customer has been with their bank</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>employment_type</TableCell>
                            <TableCell>Enum</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>EMPLOYED</TableCell>
                            <TableCell>
                                Required, the source of the customers income, one of the following values:<br/>
                                EMPLOYED, BENEFITS, or SELF_EMPLOYED (case sensitive)</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>employer_name</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>Wonka Industries</TableCell>
                            <TableCell>Required, the name of the customers employer. Must be between 1 and 150
                                characters.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>employer_length_months</TableCell>
                            <TableCell>Int</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>12</TableCell>
                            <TableCell>Required, the number of months the customer has been with their
                                employer</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>pay_frequency</TableCell>
                            <TableCell>Enum</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>MONTHLY</TableCell>
                            <TableCell>
                                Required, how often the customer is issued paycheck, one of the following values:<br/>
                                WEEKLY, BIWEEKLY, SEMI_MONTHLY, MONTHLY (case sensitive)</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>monthly_income</TableCell>
                            <TableCell>Int</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>800</TableCell>
                            <TableCell>Required, a number representing the customers total monthly income between 100 -
                                99999</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>pay_type</TableCell>
                            <TableCell>Enum</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>DIRECT_DEPOSIT</TableCell>
                            <TableCell>
                                Required, how the customer is issued their paycheck, one of the following values:<br/>
                                DIRECT_DEPOSIT, PAPER_CHECK (case sensitive)</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>next_pay_date</TableCell>
                            <TableCell>Date</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>{payDate1}</TableCell>
                            <TableCell>Required, the date of customers next paycheck in YYYY-MM-DD format. Date must be
                                in the future.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>second_pay_date</TableCell>
                            <TableCell>Date</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>{payDate2}</TableCell>
                            <TableCell>
                                Required, the date of customers paycheck AFTER the NEXT paycheck in YYYY-MM-DD
                                format.<br/>
                                Date must be after the date in the next_pay_date field.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>state_id_number</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>R500226466455</TableCell>
                            <TableCell>Required, a valid drivers license or state id number. Must be between 1 and 150
                                characters.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>state_id_issued</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>MO<br/>Missouri</TableCell>
                            <TableCell>Required, the state the state_id_number was issued in, a valid two letter state
                                abbreviation or the full state name</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>credit_score</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>VERY_GOOD</TableCell>
                            <TableCell>
                                The customers estimated credit score, one of the following values:<br/>
                                EXCELLENT, VERY_GOOD, GOOD, FAIR, POOR (case sensitive)</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>loan_purpose</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>PERSONAL</TableCell>
                            <TableCell>
                                The customer's reason for needing a loan, one of the following values:<br/>
                                DEBT_CONSOLIDATION, PAY_OFF_CREDIT_CARDS, HOME_IMPROVEMENT, MAJOR_PURCHASE, CAR_FINANCING, BUSINESS, VACATION, WEDDING_EXPENSES, MOVING_AND_RELOCATION, MEDICAL_EXPENSES, CAR_REPAIR, BILLS_AND_EVERYDAY_EXPENSES, EMERGENCY_CASH, PERSONAL, OTHER (case sensitive)
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>title_clear</TableCell>
                            <TableCell>Boolean</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>true<br/>false</TableCell>
                            <TableCell>
                                Pass true if the consumer own a vehicle with a free and clear title
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>title_as_collateral</TableCell>
                            <TableCell>Boolean</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>true<br/>false</TableCell>
                            <TableCell>
                                Pass true if the consumer is interested in using their vehicle title to obtain a larger loan amount
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>vehicle_make</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>Chevy</TableCell>
                            <TableCell>
                                If present, the make of the customers vehicle.
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>vehicle_model</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>Cruze</TableCell>
                            <TableCell>
                                If present, the model of the customers vehicle.
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>vehicle_trim</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>GT</TableCell>
                            <TableCell>
                                If present, the trim of the customers vehicle.
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>vehicle_year</TableCell>
                            <TableCell>Int</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>2020</TableCell>
                            <TableCell>
                                If present, the year of the customers vehicle.
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>vehicle_mileage</TableCell>
                            <TableCell>Int</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>100000</TableCell>
                            <TableCell>
                                If present, the number of miles on the customers vehicle.
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>minimum_loan_amount</TableCell>
                            <TableCell>Int</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>800</TableCell>
                            <TableCell>Minimum loan amount the customer is interested in between 100 - 99999</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>maximum_loan_amount</TableCell>
                            <TableCell>Int</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>2000</TableCell>
                            <TableCell>Maximum loan amount the customer is interested in between 100 - 99999</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>user_agent</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>Mozilla/5.0 (Macintosh; Intel Mac OS X...</TableCell>
                            <TableCell>Required, the user agent of the customer. Must be between 1 and 150
                                characters.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>client_ip_address</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>192.168.0.1<br/>fe80:cd00:0000:0cde:1257:0000:211e:729c</TableCell>
                            <TableCell>Required, IPV4 or IPV6 address of the customer</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>referring_site_url</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>testsite.com</TableCell>
                            <TableCell>Required, the domain name of the site from which this lead is being posted. Must
                                be between 1 and 150 characters.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>source_sub_code_1</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>100</TableCell>
                            <TableCell>
                                The traffic source (affiliate, organic, google, bing, etc.).<br/>
                                The value may be coded, ie. you may use any value to represent 'google' such as '100' or
                                'kdjf' but keep it consistent.<br/>
                                Values should not be unique - you can track your unique internal identifier within the
                                'source_lead_id' field.<br/>
                                Maximum number of characters accepted is 32.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>source_sub_code_2</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>xyz123</TableCell>
                            <TableCell>
                                The traffic medium (posted traffic, sms, ppc, seo, email, push, directmail, etc. ).<br/>
                                The value may be coded, ie. you may use any value to represent 'email' such as 'xyz123'
                                or '3d3374hd' but keep it consistent.<br/>
                                Values should not be unique - you can track your unique internal identifier within the
                                'source_lead_id' field.<br/>
                                Maximum number of characters accepted is 32.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>source_sub_code_3</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>123abc</TableCell>
                            <TableCell>
                                The traffic "campaign" (affiliate name, ppc keywords, mailing identifier, website name,
                                etc.).<br/>
                                The value may be coded, ie. you may use any value to represent 'affilate' such as
                                '123abc' or 'fndfh1' but keep it consistent.<br/>
                                Values should not be unique - you can track your unique internal identifier within the
                                'source_lead_id' field.<br/>
                                Maximum number of characters accepted is 32.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>source_lead_id</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>63565a</TableCell>
                            <TableCell>Your lead identifier you would like to associate with this request, maximum
                                number of characters accepted is 32.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>timeout</TableCell>
                            <TableCell>Decimal</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>30</TableCell>
                            <TableCell>The amount of time in seconds you are willing to wait for a response<br/>Must be
                                a number great than or equal to zero. Only numbers and a single period are accepted.
                                Minimum value is 10 seconds</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Paper>

            <Typography variant="h4" align="left">
                &quot;Ping&quot; JSON Samples
            </Typography>
            <Paper className={classes.paper}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    centered
                >
                    <Tab label="Request Body"/>
                    <Tab label="Bid Response"/>
                    <Tab label="Rejected Response"/>
                    <Tab label="Error Response"/>
                </Tabs>

                <TabPanel2 value={value} index={0}>
                    <SyntaxHighlighter language="php" style={base16AteliersulphurpoolLight}>
                        {
                            `
{
    "source_key": "` + sourceKey + `",
    "first_name": "Joesph",
    "middle_name": "B",
    "last_name": "Doe",
    "primary_email": "joe.b.doe@acquireinteractive.com",
    "home_phone": "5123486640",
    "mobile_phone": "3314727185",
    "best_call_time": "EVENING",
    "date_of_birth": "1977-06-27",
    "ssn": "200304000",
    "street_address": "123 S. Main St.",
    "street_address2": "Apt 101",
    "city": "Kansas City",
    "state": "KS",
    "zip": "66102",
    "residence_type": "OWN",
    "residence_length_months": 25,
    "military": false,
    "work_phone": "7605034396",
    "work_ext": "766",
    "bank_name": "First National Bank of Charlotte",
    "bank_routing": "123123123",
    "bank_account": "987654324",
    "bank_account_type": "CHECKING",
    "months_at_bank": 27,
    "employment_type": "EMPLOYED",
    "employer_name": "Wonka Industries",
    "employer_length_months": 12,
    "pay_frequency": "MONTHLY",
    "monthly_income": 800,
    "pay_type": "DIRECT_DEPOSIT",
    "next_pay_date": "` + payDate1 + `",
    "second_pay_date": "` + payDate2 + `",
    "state_id_number": "R500226466455",
    "state_id_issued": "MO",
    "credit_score": "VERY_GOOD",
    "title_clear": true,
    "title_as_collateral": true,
    "vehicle_make": "Chevy",
    "vehicle_model": "Cruze",
    "vehicle_trim": "GT",
    "vehicle_year": 2020,
    "vehicle_mileage": 100000,
    "minimum_loan_amount": 800,
    "maximum_loan_amount": 2000,
    "user_agent": "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_3)",
    "client_ip_address": "192.168.0.1",
    "referring_site_url": "testsite.com",
    "source_sub_code_1": "100",
    "source_sub_code_2": "xyz123",
    "source_sub_code_3": "123abc",
    "source_lead_id": "63565a",
    "timeout": 30
}
                            `}
                    </SyntaxHighlighter>
                </TabPanel2>
                <TabPanel2 value={value} index={1}>
                    <SyntaxHighlighter language="javascript" style={base16AteliersulphurpoolLight}>
                        {
                            `
{
  "request_id" : "cda49fe7-03c7-4809-8b90-f5c60b394c37",
  "request_received" : "2020-07-15T22:12:17.883Z",
  "response_rendered" : "2020-07-15T22:12:18.177Z",
  "response_time" : 6.294,
  "status" : "PRICE_REJECT",
  "amp_offer_amount" : 135.00,
  "amp_offer_token" : "0b4d40a4-574a-4436-ada5-d462c34ee27d",
  "amp_offer_expiration" : "2020-07-15T22:15:06.364Z"
}
                       `}
                    </SyntaxHighlighter>
                </TabPanel2>
                <TabPanel2 value={value} index={2}>
                    <SyntaxHighlighter language="php" style={base16AteliersulphurpoolLight}>
                        {
                            `
{
    "request_id": "a5d2e292-0506-4121-8b91-2133f6d4999a",
    "request_received": "2020-03-04T22:39:05.445Z",
    "response_rendered": "2020-03-04T22:39:06.935Z",
    "response_time": 0.703,
    "status": "REJECTED"
}                            `}
                    </SyntaxHighlighter>
                </TabPanel2>
                <TabPanel2 value={value} index={3}>
                    <SyntaxHighlighter language="php" style={base16AteliersulphurpoolLight}>
                        {
                            `
{
  "request_id": "8ddfa37a-347a-46e0-8306-b90b432cda75",
  "request_received": "2020-03-06T00:04:59.422Z",
  "response_rendered": "2020-03-06T00:04:59.425Z",
  "response_time": 0.003,
  "status": "ERROR",
  "validation_errors": {
    "firstName": [
      "must have at least 2 characters"
    ]
  }
}                         `}
                    </SyntaxHighlighter>
                </TabPanel2>
            </Paper>


            <Typography variant="h3" gutterBottom>
                Phase II: &quot;Post&quot;
            </Typography>

            <Paper className={classes.paper}>
                <Table className={classes.table} size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell variant="head">Field&nbsp;Name</TableCell>
                            <TableCell variant="head">Data&nbsp;Type</TableCell>
                            <TableCell variant="head">Required</TableCell>
                            <TableCell variant="head">Example</TableCell>
                            <TableCell variant="head">Notes</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell>amp_offer_token</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>0b4d40a4-574a-4436-ada5-d462c34ee27d</TableCell>
                            <TableCell>Required, the token returned with the bid response on the Ping.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>source_key</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>{sourceKey}</TableCell>
                            <TableCell>Required, the traffic source identifier provided by Acquire
                                Interactive</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>first_name</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>Joesph</TableCell>
                            <TableCell>Required, the customers first name, minimum number of characters accepted is 2,
                                maximum is 64.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>middle_name</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>B</TableCell>
                            <TableCell>If present, the customers middle name, minimum number of characters accepted is
                                2, maximum is 64.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>last_name</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>Doe</TableCell>
                            <TableCell>Required, the customers last name, minimum number of characters accepted is 2,
                                maximum is 64.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>primary_email</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>joe.b.doe@acquireinteractive.com</TableCell>
                            <TableCell>Required, the customers valid, well formed email address, maximum length is 128
                                characters.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>home_phone</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>5123486640</TableCell>
                            <TableCell>
                                A valid home_phone or mobile_phone for the customer is required. Both can be
                                provided.<br/>
                                Send only the 10 significant numbers that make up the phone number.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>mobile_phone</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>3314727185</TableCell>
                            <TableCell>
                                A valid mobile_phone or home_phone for the customer is required. Both can be
                                provided.<br/>
                                Send only the 10 significant numbers that make up the phone number.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>best_call_time</TableCell>
                            <TableCell>Enum</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>EVENING</TableCell>
                            <TableCell>
                                Best time to contact customer, one of the following values:<br/>
                                MORNING, AFTERNOON, EVENING (case sensitive)</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>date_of_birth</TableCell>
                            <TableCell>Date</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>1977-06-27</TableCell>
                            <TableCell>Required, the customers date of birth in YYYY-MM-DD format. Date must represent
                                applicants age as 18 or older as of this day.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>ssn</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>200304000</TableCell>
                            <TableCell>Required, send only the 9 significant numbers that make up the customers Social
                                Security Number.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>street_address</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>123 S. Main St.</TableCell>
                            <TableCell>Required, the customers street address, minimum number of characters accepted is
                                6, maximum is 128.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>street_address2</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>Apt 101</TableCell>
                            <TableCell>The customers additional street address, maximum number of characters accepted is
                                128.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>city</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>Kansas City</TableCell>
                            <TableCell>Required, the customers city, minimum number of characters accepted is 1, maximum
                                is 128.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>state</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>KS<br/>Kansas</TableCell>
                            <TableCell>Required, the customers state, a valid two letter state abbreviation or the full
                                state name</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>zip</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>66102<br/>66102-3225</TableCell>
                            <TableCell>Required, send either the 5 digit ZIP Code or the 10 digit ZIP+4 with the dash in
                                it.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>residence_type</TableCell>
                            <TableCell>Enum</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>OWN</TableCell>
                            <TableCell>
                                Required, does the customer own or rent their residence, one of the following
                                values:<br/>
                                RENT, OWN (case sensitive)</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>residence_length_months</TableCell>
                            <TableCell>Int</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>25</TableCell>
                            <TableCell>Required, Number of months the customer has been at their residence</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>military</TableCell>
                            <TableCell>Boolean</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>true<br/>false</TableCell>
                            <TableCell>Required, is the customer active duty military?</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>work_phone</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>7605034396</TableCell>
                            <TableCell>Required, send only the 10 significant numbers that make up the phone
                                number.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>work_ext</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>766</TableCell>
                            <TableCell>The customers work extension, maximum number of characters accepted is 10 digits
                                (only numbers allowed).</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>bank_name</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>First National Bank of Charlotte</TableCell>
                            <TableCell>Required, name of the customers banking institution. Must be between 1 and 150
                                characters.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>bank_routing</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>123123123</TableCell>
                            <TableCell>Required, customers bank account routing number. Must be exactly nine digits,
                                (only numbers allowed).</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>bank_account</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>987654324</TableCell>
                            <TableCell>Required, customers valid bank account number. Must be between 2 and 21 alpha
                                numeric characters.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>bank_account_type</TableCell>
                            <TableCell>Enum</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>CHECKING</TableCell>
                            <TableCell>Required, customers type of bank account. CHECKING or SAVINGS (case
                                sensitive)</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>months_at_bank</TableCell>
                            <TableCell>Int</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>27</TableCell>
                            <TableCell>Number of months the customer has been with their bank</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>employment_type</TableCell>
                            <TableCell>Enum</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>EMPLOYED</TableCell>
                            <TableCell>
                                Required, the source of the customers income, one of the following values:<br/>
                                EMPLOYED, BENEFITS, or SELF_EMPLOYED (case sensitive)</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>employer_name</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>Wonka Industries</TableCell>
                            <TableCell>Required, the name of the customers employer. Must be between 1 and 150
                                characters.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>employer_length_months</TableCell>
                            <TableCell>Int</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>12</TableCell>
                            <TableCell>Required, the number of months the customer has been with their
                                employer</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>pay_frequency</TableCell>
                            <TableCell>Enum</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>MONTHLY</TableCell>
                            <TableCell>
                                Required, how often the customer is issued paycheck, one of the following values:<br/>
                                WEEKLY, BIWEEKLY, SEMI_MONTHLY, MONTHLY (case sensitive)</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>monthly_income</TableCell>
                            <TableCell>Int</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>800</TableCell>
                            <TableCell>Required, a number representing the customers total monthly income between 100 -
                                99999</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>pay_type</TableCell>
                            <TableCell>Enum</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>DIRECT_DEPOSIT</TableCell>
                            <TableCell>
                                Required, how the customer is issued their paycheck, one of the following values:<br/>
                                DIRECT_DEPOSIT, PAPER_CHECK (case sensitive)</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>next_pay_date</TableCell>
                            <TableCell>Date</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>{payDate1}</TableCell>
                            <TableCell>Required, the date of customers next paycheck in YYYY-MM-DD format. Date must be
                                in the future.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>second_pay_date</TableCell>
                            <TableCell>Date</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>{payDate2}</TableCell>
                            <TableCell>
                                Required, the date of customers paycheck AFTER the NEXT paycheck in YYYY-MM-DD
                                format.<br/>
                                Date must be after the date in the next_pay_date field.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>state_id_number</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>R500226466455</TableCell>
                            <TableCell>Required, a valid drivers license or state id number. Must be between 1 and 150
                                characters.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>state_id_issued</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>MO<br/>Missouri</TableCell>
                            <TableCell>Required, the state the state_id_number was issued in, a valid two letter state
                                abbreviation or the full state name</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>credit_score</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>VERY_GOOD</TableCell>
                            <TableCell>
                                The customers estimated credit score, one of the following values:<br/>
                                EXCELLENT, VERY_GOOD, GOOD, FAIR, POOR (case sensitive)</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>loan_purpose</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>PERSONAL</TableCell>
                            <TableCell>
                                The customer's reason for needing a loan, one of the following values:<br/>
                                DEBT_CONSOLIDATION, PAY_OFF_CREDIT_CARDS, HOME_IMPROVEMENT, MAJOR_PURCHASE, CAR_FINANCING, BUSINESS, VACATION, WEDDING_EXPENSES, MOVING_AND_RELOCATION, MEDICAL_EXPENSES, CAR_REPAIR, BILLS_AND_EVERYDAY_EXPENSES, EMERGENCY_CASH, PERSONAL, OTHER (case sensitive)
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>title_clear</TableCell>
                            <TableCell>Boolean</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>true<br/>false</TableCell>
                            <TableCell>
                                Pass true if the consumer own a vehicle with a free and clear title
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>title_as_collateral</TableCell>
                            <TableCell>Boolean</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>true<br/>false</TableCell>
                            <TableCell>
                                Pass true if the consumer is interested in using their vehicle title to obtain a larger loan amount
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>minimum_loan_amount</TableCell>
                            <TableCell>Int</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>800</TableCell>
                            <TableCell>Minimum loan amount the customer is interested in between 100 - 99999</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>maximum_loan_amount</TableCell>
                            <TableCell>Int</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>2000</TableCell>
                            <TableCell>Maximum loan amount the customer is interested in between 100 - 99999</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>user_agent</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>Mozilla/5.0 (Macintosh; Intel Mac OS X...</TableCell>
                            <TableCell>Required, the user agent of the customer. Must be between 1 and 150
                                characters.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>client_ip_address</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>192.168.0.1<br/>fe80:cd00:0000:0cde:1257:0000:211e:729c</TableCell>
                            <TableCell>Required, IPV4 or IPV6 address of the customer</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>referring_site_url</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>testsite.com</TableCell>
                            <TableCell>Required, the domain name of the site from which this lead is being posted. Must
                                be between 1 and 150 characters.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>source_sub_code_1</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>100</TableCell>
                            <TableCell>
                                The traffic source (affiliate, organic, google, bing, etc.).<br/>
                                The value may be coded, ie. you may use any value to represent 'google' such as '100' or
                                'kdjf' but keep it consistent.<br/>
                                Values should not be unique - you can track your unique internal identifier within the
                                'source_lead_id' field.<br/>
                                Maximum number of characters accepted is 32.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>source_sub_code_2</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>xyz123</TableCell>
                            <TableCell>
                                The traffic medium (posted traffic, sms, ppc, seo, email, push, directmail, etc. ).<br/>
                                The value may be coded, ie. you may use any value to represent 'email' such as 'xyz123'
                                or '3d3374hd' but keep it consistent.<br/>
                                Values should not be unique - you can track your unique internal identifier within the
                                'source_lead_id' field.<br/>
                                Maximum number of characters accepted is 32.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>source_sub_code_3</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>123abc</TableCell>
                            <TableCell>
                                The traffic "campaign" (affiliate name, ppc keywords, mailing identifier, website name,
                                etc.).<br/>
                                The value may be coded, ie. you may use any value to represent 'affilate' such as
                                '123abc' or 'fndfh1' but keep it consistent.<br/>
                                Values should not be unique - you can track your unique internal identifier within the
                                'source_lead_id' field.<br/>
                                Maximum number of characters accepted is 32.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>source_lead_id</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>63565a</TableCell>
                            <TableCell>Your lead identifier you would like to associate with this request, maximum
                                number of characters accepted is 32.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>timeout</TableCell>
                            <TableCell>Decimal</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>30</TableCell>
                            <TableCell>The amount of time in seconds you are willing to wait for a response<br/>Must be
                                a number great than or equal to zero. Only numbers and a single period are accepted.
                                Minimum value is 10 seconds</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Paper>

            <Typography variant="h4" align="left">
                &quot;POST&quot; JSON Samples
            </Typography>
            <Paper className={classes.paper}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    centered
                >
                    <Tab label="Request Body"/>
                    <Tab label="Accepted Response"/>
                    <Tab label="Rejected Response"/>
                    <Tab label="Error Response"/>
                </Tabs>

                <TabPanel2 value={value} index={0}>
                    <SyntaxHighlighter language="php" style={base16AteliersulphurpoolLight}>
                        {
                            `
{
    "amp_offer_token": "0b4d40a4-574a-4436-ada5-d462c34ee27d",
    "source_key": "` + sourceKey + `",
    "first_name": "Joesph",
    "middle_name": "B",
    "last_name": "Doe",
    "primary_email": "joe.b.doe@acquireinteractive.com",
    "home_phone": "5123486640",
    "mobile_phone": "3314727185",
    "best_call_time": "EVENING",
    "date_of_birth": "1977-06-27",
    "ssn": "200304000",
    "street_address": "123 S. Main St.",
    "street_address2": "Apt 101",
    "city": "Kansas City",
    "state": "KS",
    "zip": "66102",
    "residence_type": "OWN",
    "residence_length_months": 25,
    "military": false,
    "work_phone": "7605034396",
    "work_ext": "766",
    "bank_name": "First National Bank of Charlotte",
    "bank_routing": "123123123",
    "bank_account": "987654324",
    "bank_account_type": "CHECKING",
    "months_at_bank": 27,
    "employment_type": "EMPLOYED",
    "employer_name": "Wonka Industries",
    "employer_length_months": 12,
    "pay_frequency": "MONTHLY",
    "monthly_income": 800,
    "pay_type": "DIRECT_DEPOSIT",
    "next_pay_date": "` + payDate1 + `",
    "second_pay_date": "` + payDate2 + `",
    "state_id_number": "R500226466455",
    "state_id_issued": "MO",
    "credit_score": "VERY_GOOD",
    "title_clear": true,
    "title_as_collateral": true,
    "vehicle_make": "Chevy",
    "vehicle_model": "Cruze",
    "vehicle_trim": "GT",
    "vehicle_year": 2020,
    "vehicle_mileage": 100000,
    "minimum_loan_amount": 800,
    "maximum_loan_amount": 2000,
    "user_agent": "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_3)",
    "client_ip_address": "192.168.0.1",
    "referring_site_url": "testsite.com",
    "source_sub_code_1": "100",
    "source_sub_code_2": "xyz123",
    "source_sub_code_3": "123abc",
    "source_lead_id": "63565a",
    "timeout": 30
}
                            `}
                    </SyntaxHighlighter>
                </TabPanel2>
                <TabPanel2 value={value} index={1}>
                    <SyntaxHighlighter language="javascript" style={base16AteliersulphurpoolLight}>
                        {
                            `
{
  "request_id": "76373fc5-7ecb-4494-9041-7bc216951210",
  "request_received": "2020-03-10T20:07:36.358Z",
  "response_rendered": "2020-03-10T20:07:44.351Z",
  "response_time": 0.339,
  "status": "ACCEPTED",
  "redirect_url": "https://acceleratedmarketplace.com/loan/redirect/76373fc5-7ecb-4494-9041-7bc216951210",
  "payout": 135.00
} 
                       `}
                    </SyntaxHighlighter>
                </TabPanel2>
                <TabPanel2 value={value} index={2}>
                    <SyntaxHighlighter language="php" style={base16AteliersulphurpoolLight}>
                        {
                            `
{
    "request_id": "a5d2e292-0506-4121-8b91-2133f6d4999a",
    "request_received": "2020-03-04T22:39:05.445Z",
    "response_rendered": "2020-03-04T22:39:06.935Z",
    "response_time": 0.003,
    "status": "REJECTED"
}                            `}
                    </SyntaxHighlighter>
                </TabPanel2>
                <TabPanel2 value={value} index={3}>
                    <SyntaxHighlighter language="php" style={base16AteliersulphurpoolLight}>
                        {
                            `
{
  "request_id": "8ddfa37a-347a-46e0-8306-b90b432cda75",
  "request_received": "2020-03-06T00:04:59.422Z",
  "response_rendered": "2020-03-06T00:04:59.425Z",
  "response_time": 0.003,
  "status": "ERROR",
  "validation_errors": {
    "firstName": [
      "must have at least 2 characters"
    ]
  }
}                         `}
                    </SyntaxHighlighter>
                </TabPanel2>
            </Paper>
        </>
    );
};

export default PostingInstructions
